import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { InboundPostmarkLink } from "../util/Links";

const EmailModal = ({ visible, close, email, postmark }) => {
  if (email === null || email === undefined) return;
  return (
    <Modal
      show={visible}
      onHide={close}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          <div>
            {email?.subject} {" - "}
            {InboundPostmarkLink(postmark, "Postmark Link")}
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div
            id={"axis-external-email"}
            dangerouslySetInnerHTML={{ __html: email?.content }}
          ></div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className={"w-50"} onClick={close}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EmailModal;
